import React, { useEffect, useState, useRef } from "react";
import { debounce } from "lodash";
import Keeper from "../../shared/Keeper";
import { StyledKeepers, StyledKeepersList, StyledDecoyContainer } from "./styles";
import { StyledThumbsUp } from "../../shared/styles";
import { sendAppEvent } from "../../../../Utils";
import ThumbsUp from "../../shared/ThumbsUp";

const Keepers = ({
  closeBrainstorm,
  keepersList,
  setKeepers,
  setItems,
  items,
  setEndTime,
  setCurrentScreen,
  setQueuedItems,
  starters,
  children,
  animating,
  setKeepersListScrolled,
  rejected,
  setRejected,
}) => {
  const [editing, setEditing] = useState(false); //false or an index
  const keepersListRef = useRef(null);

  useEffect(() => {
    // clear queue whenever keepers changes
    // with an adequate debounce
    function keepersMatchStarters() {
      if (!keepersList || !starters) return;
      //check to see if they match so we don't clear immediately
      if (keepersList.length !== starters.length) return false;
      for (let i = 0; i < keepersList.length; i++) {
        if (keepersList[i] !== starters[i]) return false;
      }
      return true;
    }

    const clearItems = debounce(
      () => {
        setQueuedItems([]);
      },
      1500,
      { trailing: true }
    );

    if (editing === false && keepersList.indexOf("") < 0 && !keepersMatchStarters()) {
      clearItems();
    }
  }, [keepersList]);

  useEffect(
    (e) => {
      if (keepersListRef.current) {
        let isScrolled = keepersListRef.current.scrollHeight > keepersListRef.current.clientHeight;
        setKeepersListScrolled(isScrolled);
      }

      if (animating && keepersListRef.current) {
        keepersListRef.current.scrollTop = 0;
      }
    },
    [animating]
  );

  const handleDoneClick = async () => {
    const now = new Date().getTime();
    setEndTime(now);
    await closeBrainstorm(now);
    sendAppEvent("Brainstorm - Screen 3 Done Button");
  };
  return (
    <StyledKeepers>
      <StyledDecoyContainer>{children}</StyledDecoyContainer>
      <h3>
        <StyledThumbsUp>
          <ThumbsUp opacity={"1"} color={"var(--grey-1)"} />
        </StyledThumbsUp>
        &nbsp;&nbsp;Keepers
      </h3>
      <span
        onClick={() => {
          setKeepers([""].concat(keepersList));
          setEditing(0);
        }}
      >
        +
      </span>
      <StyledKeepersList ref={keepersListRef}>
        {!keepersList.length && <p>Give a thumbs up to some ideas, and the AI will use them to improve your results.</p>}
        {keepersList.map((keeper, i) => {
          return (
            <Keeper
              key={"keeper_" + keeper}
              content={keeper}
              index={i}
              setKeepers={setKeepers}
              keepers={keepersList}
              setItems={setItems}
              items={items}
              editing={editing}
              setEditing={setEditing}
              rejected={rejected}
              setRejected={setRejected}
            />
          );
        })}
      </StyledKeepersList>
      <div className="done-btn" onClick={handleDoneClick}>
        Save &amp; Exit
      </div>
    </StyledKeepers>
  );
};

export default Keepers;
